import router from '@/router'
import { prohibitAuth } from '@/core/routerGuards'

router.addRoute({
	path: '/login',
	name: 'Login',
	component: () => import('./pages/Login.vue'),
	beforeEnter: prohibitAuth,
})
